import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import Strategist from "@/pages/Strategist";
import Generals from "@/pages/Generals";
import GeneralDetail from "@/pages/GeneralDetail";
import Monsters from "@/pages/Monsters";
import MonsterDetail from "@/pages/MonsterDetail";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import DebugConsole from "@/App";

export default function Root() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/debug" element={<DebugConsole />} />
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Strategist />} />
                <Route path="/generals" element={<Generals />} />
                <Route path="/generals/:slug" element={<GeneralDetail />} />
                <Route path="/monsters" element={<Monsters />} />
                <Route path="/monsters/:slug" element={<MonsterDetail />} />
                <Route path="/guides" element={<Guides />} />
                <Route path="/guides/:slug" element={<GuideDetail />} />
                <Route path="*" element={<Strategist />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
